export default __webpack_public_path__ + "static/media/Knock Back.5d570efa.png";